'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Height and width consts for all AOI's
var height = 130;
var width = height * 1.8;

// Colors for vehicles and people
var vColor = 'rgba(255, 0, 0, 1)';
var pColor = 'rgba(0, 0, 255, .6)';

function drawAoiOnCanvas(ctx, color, aoi) {
  // We use beginPath+rect+fill instead of fillRect because
  // rectangles from a single AOI can overlap, and we don't want
  // to apply gradients on top of overlapping rects from one AOI

  ctx.beginPath();
  ctx.fillStyle = color;

  // eslint-disable-next-line no-restricted-syntax
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(aoi), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var pAoi = _step.value;

      ctx.rect(pAoi.x * width, pAoi.y * height, pAoi.width * width, pAoi.height * width);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  ctx.fill();
}

var CameraChart = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CameraChart, _Component);

  function CameraChart() {
    (0, _classCallCheck3.default)(this, CameraChart);
    return (0, _possibleConstructorReturn3.default)(this, (CameraChart.__proto__ || (0, _getPrototypeOf2.default)(CameraChart)).apply(this, arguments));
  }

  (0, _createClass3.default)(CameraChart, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateCanvas();
    }
  }, {
    key: 'updateCanvas',
    value: function updateCanvas() {
      var areaOfInterestData = this.props.areaOfInterestData;


      var ctx = this.refs.canvas.getContext('2d');

      drawAoiOnCanvas(ctx, vColor, areaOfInterestData.vehicle_aoi);
      drawAoiOnCanvas(ctx, pColor, areaOfInterestData.person_aoi);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { 'font-weight': 'bold' } },
          _react2.default.createElement(
            'span',
            { style: { color: vColor } },
            'Vehicles'
          ),
          _react2.default.createElement(
            'span',
            null,
            ' and '
          ),
          _react2.default.createElement(
            'span',
            { style: { color: pColor } },
            'People'
          )
        ),
        _react2.default.createElement('canvas', {
          ref: 'canvas',
          width: width,
          height: height,
          style: { border: '1px solid #000000' }
        })
      );
    }
  }]);
  return CameraChart;
}(_react.Component), _class.propTypes = {
  areaOfInterestData: _react.PropTypes.object
}, _temp);
exports.default = CameraChart;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AreaOfInterest/AreaOfInterest.js
 ** module id = 1376
 ** module chunks = 0
 **/